import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appEnterToNext]'
})
export class EnterToNextDirective {

  constructor(private el: ElementRef<HTMLInputElement>) {}

  @HostListener('keydown.enter', ['$event'])
  onEnter(event: Event) {
    event.preventDefault();

    const keyboardEvent = event as KeyboardEvent;

    const inputs: HTMLElement[] = Array.from(
      document.querySelectorAll(
        'input:not([disabled]):not([readonly]):not([type=hidden]), select, textarea'
      )
    );

    const index = inputs.indexOf(this.el.nativeElement);

    if (index > -1 && index < inputs.length - 1) {
      (inputs[index + 1] as HTMLElement).focus();
    }
  }
}
